import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 去掉重复跳转报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return (originalPush.call(this, location) as any).catch((err) => err);
};

let routes = [
  { path: "/", redirect: "web" }, // 重定位
  {
    path: "/login",
    component: () => import("./pages/login.vue"),
  },
  {
    path: "/register",
    component: () => import("./pages/register.vue"),
  },
  {
    path: "/home",
    component: () => import("./pages/home/index.vue"),
    children: [
      { path: "/home", redirect: "modelManagement" },
      // { path: '/home/index', component: () => import('./pages/home/index.vue') },
      // { path: '/home/fileManage', component: () => import('./pages/home/fileManage.vue') },
      {
        path: "/home/userManage",
        component: () => import("./pages/home/userManage.vue"),
      },
      {
        path: "/home/projectManagement",
        component: () =>
          import("./pages/home/projectManagement/projectManagement.vue"),
      },
      {
        path: "/home/gisManagement",
        component: () => import("./pages/home/gisManagement/gisManagement.vue"),
      },
      {
        path: "/home/modelManagement",
        component: () =>
          import("./pages/home/modelManagement/modelManagement.vue"),
      },
      // {
      //   path: "/home/versionManagement",
      //   component: () => import("./pages/home/versionManagement/versionManagement.vue"),
      // },
      {
        path: "/home/gisManagement",
        component: () => import("./pages/home/gisManagement/gisManagement.vue"),
      },
      {
        path: "/home/gisTreeManagement",
        component: () =>
          import("./pages/home/gisTreeManagement/gisTreeManagement.vue"),
      },
      {
        path: "/home/structureTreeManagement",
        component: () =>
          import(
            "./pages/home/structureTreeManagement/structureTreeManagement.vue"
          ),
      },
      {
        path: "/home/gisTreeManagement",
        component: () =>
          import("./pages/home/gisTreeManagement/gisTreeManagement.vue"),
      },
      {
        path: "/home/personalManagement",
        component: () =>
          import("./pages/home/personalManagement/personalManagement.vue"),
      },
      {
        path: "/home/roleManagement",
        component: () =>
          import("./pages/home/roleManagement/roleManagement.vue"),
      },
      {
        path: "/home/permissionManagement",
        component: () =>
          import("./pages/home/permissionManagement/permissionManagement.vue"),
      },
      {
        path: "/home/userManagement",
        component: () =>
          import("./pages/home/userManagement/userManagement.vue"),
      },
      {
        path: "/home/userCenter",
        component: () => import("./pages/home/userCenter/userCenter.vue"),
      },
    ],
  },
  // {
  //   path: "/projectConfig",
  //   component: () => import("./pages/projectConfig/index.vue"),
  //   children: [
  //     { path: "/projectConfig", redirect: "structureTreeManagement" },
  //     {
  //       path: "/projectConfig/structureTreeManagement",
  //       component: () =>
  //         import("./pages/projectConfig/structureTreeManagement/structureTreeManagement.vue"),
  //     },
  //     {
  //       path: "/projectConfig/personalManagement",
  //       component: () => import("./pages/projectConfig/personalManagement/personalManagement.vue"),
  //     },
  //   ],
  // },
  // {
  //   path: "/bimAir",
  //   component: () => import("./pages/modelEdit/bimAirExport.vue"),
  // },
  {
    path: "/modelEdit",
    component: () => import("./pages/modelEdit/index.vue"),
  },

  {
    path: "/modelComparison",
    component: () => import("./pages/modelComparison/modelComparison.vue"),
  },

  {
    path: "/projectEdit",
    component: () => import("./pages/projectEdit/index.vue"),
  },
  {
    path: "/web",
    component: () => import("./pages/web/index.vue"),
    children: [
      { path: "/web", redirect: "home" },
      {
        path: "/web/home",
        component: () => import("./pages/web/home/index.vue"),
      },
      {
        path: "/web/functionIntroduction",
        component: () => import("./pages/web/functionIntroduction/index.vue"),
      },
      {
        path: "/web/projectCase",
        component: () => import("./pages/web/projectCase/index.vue"),
      },
      {
        path: "/web/demo",
        component: () => import("./pages/web/demo/index.vue"),
        meta: {
          background: "#05081a",
        },
      },
      //apiDoc，原前端开发文档，现已迁移到/web/apiDocs/webDocs
      // {
      //   path: "/web/apiDoc",
      //   component: () => import("./pages/web/apiDoc/index.vue"),
      // },
      {
        path: "/web/quickStart",
        component: () => import("./pages/web/quickStart/index.vue"),
      },
      {
        path: "/web/apiDocs/webDocs",
        component: () => import("./pages/web/apiDocs/webDocs/index.vue"),
      },
      {
        path: "/web/apiDocs/serviceDocs",
        component: () => import("./pages/web/apiDocs/serviceDocs/index.vue"),
      },
      // 工程案例project case
      {
        path: "/web/projectCase",
        component: () => import("./pages/web/projectCase/index.vue"),
      },
      // 服务与支持 service and support
      {
        path: "/web/serviceAndSupport",
        component: () => import("./pages/web/serviceAndSupport/index.vue"),
      },
      {
        path: "/web/commonProblem",
        component: () => import("./pages/web/commonProblem/index.vue"),
      },
      {
        path: "/web/updateLog",
        component: () => import("./pages/web/updateLog/index.vue"),
      },
    ],
  },
  {
    path: "/modelEditTest",
    component: () => import("../packages/testDemo/src/index.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("./pages/notFound.vue"),
  },
];

// if (process.env.NODE_ENV !== "production") {
//   routes.push({
//     path: "/modelEditTest",
//     component: () => import("../packages/testDemo/src/index.vue"),
//   });
// }

// 创建并返回 router 实例的函数
function createRouter() {
  const router = new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
  });

  // 路由守卫
  router.beforeEach((to, from, next) => {
    // 递归检查所有路由，包括子路由
    function routeExists(routes: any[], path: string): boolean {
      return routes.some((route) => {
        if (route.path === path) {
          return true;
        }
        if (route.children) {
          return routeExists(route.children, path);
        }
        return false;
      });
    }
    // 检查目标路由是否在 routes 中存在，包括子路由
    const isRouteConfigured = routeExists(routes, to.path);
    console.log("当前路由是：", to);

    if (!isRouteConfigured) {
      console.log("/404");
      next("/404"); // 阻止跳转
    } else {
      next(); // 允许跳转
    }
  });

  return router;
}

// 导出一个获取 router 的函数，避免直接使用 router 引用导致循环依赖
export default createRouter();
